import type { Catalog, EntryId, ISODate } from "@schema/catalog.ts";

/**
 * Phase of the first unwatched entry in road order — where you actually are in
 * the marathon. Falls to the last phase once everything is watched. Pure.
 */
export function firstUnwatchedPhaseId(
  catalog: Catalog,
  watched: Record<EntryId, ISODate>,
): string | null {
  for (const entry of catalog.entries) if (!watched[entry.id]) return entry.phaseId;
  return catalog.entries.at(-1)?.phaseId ?? null;
}
